import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'projects',
  size: 'full',
  children: {
    onboarding: {
      path: 'onboarding',
      size: 'full',
    },
    importDetails: {
      path: 'import_details',
      size: 'full',
    },
    contributors: {
      path: 'contributors',
      size: 'full',
      children: {
        list: {
          path: 'list',
          size: 'full',
        },
        contributorId: {
          path: ':employeeId',
          size: 'full',
          children: {
            overview: {
              size: 'full',
              path: 'overview',
            },
            yearMonthDay: {
              size: 'full',
              path: ':year/:month/:day',
            },
            schedule: {
              size: 'full',
              path: 'schedule',
            },
          },
        },
      },
    },
    jobsAndRates: {
      path: 'jobs-and-rates',
      size: 'full',
      children: {
        list: {
          path: 'list',
          size: 'full',
        },
        rateId: {
          path: ':rateId',
          size: 'full',
        },
      },
    },
    list: {
      path: 'list',
      size: 'full',
      children: {
        create: {
          path: 'create',
          size: 'full',
        },
        export: {
          path: 'export',
          size: 'full',
        },
        import: {
          path: 'import',
          size: 'full',
        },
        workers: {
          path: 'workers',
          size: 'full',
        },
        projectId: {
          path: ':projectId',
          size: 'full',
          children: {
            edit: {
              path: 'edit',
              size: 'full',
            },
            duplicate: {
              path: 'duplicate',
              size: 'full',
            },
            close: {
              path: 'close',
              size: 'full',
            },
            reopen: {
              path: 'reopen',
              size: 'full',
            },
            delete: {
              path: 'delete',
              size: 'full',
            },
          },
        },
      },
    },
    id: {
      path: ':id',
      children: {
        details: {
          path: 'details',
          size: 'full',
          children: {
            overview: {
              path: 'overview',
              size: 'full',
              children: {
                export: {
                  path: 'export',
                  size: 'full',
                },
              },
            },
            employees: {
              path: 'employees',
              size: 'full',
              children: {
                export: {
                  path: 'export',
                  size: 'full',
                },
                workers: {
                  path: 'workers',
                  size: 'full',
                },
                unassignEmployee: {
                  path: 'unassign-employee',
                  size: 'full',
                  children: {
                    employeeId: {
                      size: 'full',
                      path: ':employeeId',
                      children: {
                        projectWorkerId: {
                          size: 'full',
                          path: ':projectWorkerId',
                        },
                      },
                    },
                  },
                },
                assignEmployee: {
                  path: 'assign-employee',
                  size: 'full',
                  children: {
                    employeeId: {
                      size: 'full',
                      path: ':employeeId',
                      children: {
                        projectWorkerId: {
                          size: 'full',
                          path: ':projectWorkerId',
                        },
                      },
                    },
                  },
                },
              },
            },
            subprojects: {
              path: 'subprojects',
              size: 'full',
              children: {
                create: {
                  path: 'create',
                  size: 'full',
                },
                export: {
                  path: 'export',
                  size: 'full',
                },
                subprojectId: {
                  path: ':subprojectId',
                  size: 'full',
                  children: {
                    edit: {
                      path: 'edit',
                      size: 'full',
                    },
                    delete: {
                      path: 'delete',
                      size: 'full',
                    },
                  },
                },
              },
            },
            spending: {
              path: 'spending',
              size: 'full',
            },
            tasks: {
              path: 'tasks',
              size: 'full',
              children: {
                create: {
                  path: 'create',
                  size: 'full',
                },
                taskId: {
                  path: ':taskId',
                  size: 'full',
                },
              },
            },
            sale_invoices: {
              path: 'sale_invoices',
              size: 'full',
              children: {
                detail: {
                  path: 'detail/:invoiceId',
                  size: 'full',
                  children: {
                    documents: {
                      size: 'full',
                      path: 'documents',
                    },
                    overview: {
                      size: 'full',
                      path: 'overview',
                    },
                    form: {
                      path: 'form',
                      size: 'full',
                    },
                  },
                },
                create: {
                  path: 'create',
                  size: 'full',
                },
                invoiceId: {
                  path: ':invoiceId',
                  size: 'full',
                },
                export: {
                  path: 'export',
                  size: 'full',
                },
              },
            },
            documents: {
              path: 'documents',
              size: 'full',
            },
          },
        },
        settings: {
          path: 'settings',
          size: 'full',
        },
      },
    },
    schedule: {
      path: 'schedule',
      size: 'full',
      children: {
        contributors: {
          path: 'contributors',
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
